module.exports = __webpack_public_path__ + "img/10.771bbf4c.png";